import { DraftConfiguration, DraftState, PrintArea } from '@/types';
import { getAppearance } from '@/model/draft/getAppearance';
import { getConfiguration } from '@/model/draft/getConfiguration';
import { getProductType } from '@/model/draft/getProductType';
import { getViewForPrintArea } from '@/model/productType/getViewForPrintArea';
import { equalizeOnAdd } from './helper/equalizeOnAdd';
import { setPrintAreaOfConfiguration } from './helper/setPrintAreaOfConfiguration';

export const switchPrintAreaAction =
  ({ cid }: DraftConfiguration, newPrintArea: PrintArea) =>
  (draft: DraftState) => {
    const productType = getProductType(draft);
    const configuration = getConfiguration(draft, cid);
    const appearance = getAppearance(draft);

    setPrintAreaOfConfiguration(configuration, appearance, newPrintArea);

    draft.view = getViewForPrintArea(productType, newPrintArea);

    equalizeOnAdd(draft, configuration);
  };
